import { FileText } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { BillOfLadingPage } from './pages/BillOfLadingPage'

/**
 * Standard Bill of Lading generator (2026-09-10). Pure form-to-PDF, no
 * Odoo binding -- there's no outbound-shipment record to bind to yet.
 * Fill the form, download the PDF, email it to the carrier yourself
 * (no automated send, per the project's email hard rule).
 */
export default defineModule({
  id: 'bill-of-lading',
  name: 'Bill of Lading',
  shortName: 'BOL',
  icon: FileText,
  navSection: 'logistics',
  navOrder: 70,
  urlNamespace: '/bill-of-lading',
  routes: [
    { path: '/', element: BillOfLadingPage, label: 'Bill of Lading' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g b l',

  commandPaletteEntries: [
    {
      label: 'Go to Bill of Lading',
      keywords: ['bol', 'bill of lading', 'shipping', 'shipper', 'consignee', 'carrier', 'freight'],
      path: '/',
      group: 'modules',
      shortcut: 'g b l',
    },
  ],
})
